/* eslint-disable no-restricted-globals */
import { useEffect } from 'react';
import PropTypes from 'prop-types';

import Metrics from '@spotahome/soyuz-tracking';

import { useCookie } from '../utils/withCookie';

const COOKIE_VALUE = 'google';

const sendMetrics = notification => {
  Metrics.ga.sendEvent('GoogleOneTap', 'toast', 'appear');
  if (notification.getSkippedReason() === 'user_cancel') {
    Metrics.ga.sendEvent('GoogleOneTap', 'toast', 'user_skipped');
  }
};

const GoogleOneTap = ({ googleOneTapId, handleSuccessCallback }) => {
  const cookieManager = useCookie();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleScriptLoad = () => {
    if (window.google.accounts) {
      window.google.accounts.id.initialize({
        client_id: googleOneTapId,
        callback: handleSuccessCallback,
        cancel_on_tap_outside: false,
        context: 'use'
      });
      window.google.accounts.id.prompt(sendMetrics);
    }
  };

  useEffect(() => {
    const mustCreateScript =
      cookieManager.getCookie('authMethod') === COOKIE_VALUE ||
      !cookieManager.getCookie('authMethod');

    if (mustCreateScript) {
      const script = document.createElement('script');
      script.defer = true;
      script.src = 'https://accounts.google.com/gsi/client';
      script.onload = handleScriptLoad;

      document.body.appendChild(script);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

GoogleOneTap.propTypes = {
  googleOneTapId: PropTypes.string.isRequired,
  handleSuccessCallback: PropTypes.func.isRequired
};

export default GoogleOneTap;
